// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/decide-model.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/decide-model/decide-model.js';

mount([g0]);
